module.exports = __webpack_public_path__ + "static/media/travelpacker.bfd9f75d.png";